// --------------------------------------------------------------------------
// #107 - Bird selector
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();

require('jquery-ui/position');
require('jquery-ui/draggable');
require('jquery-ui/resizable');
require('jquery-ui/menu');
require('jquery-ui/autocomplete');

module.exports = function (options) {
    var context = options.context;
    var $birdSearch = $(context).find('[data-binding="bird-search"]');

    var itemsForSelection = [];

    function getItemIndexByLabel(inputValue) {
        for (var i = 0; i < itemsForSelection.length; i++) {
            if (itemsForSelection[i].label === inputValue) {
                return i;
            }
        }

        return null;
    }

    function init() {

        var $birdItems = $(context).find('[data-binding="bird-item"]');
        var $birdList = $(context).find('[data-binding="bird-data"]').children();
        var birdCount = $birdList.length;

        // Loop over the bird items
        $birdItems.each(function () {

            // Find the inputs
            var $input = $(this).find('[data-binding="input-number"]');

            // If the existing input is > 0
            if ($input.val() > 0) {

                // Show the input
                $input.show();

                // Show the sibling buttons too
                $input.siblings('.input-number__button').show();
            }
        });

        // Loop through birds and create array
        for (var i = 0; i < birdCount; i++) {
            var birdListItemElement = $($birdList[i]);
            var item = {
                value: birdListItemElement.attr('value') + '|' + birdListItemElement.attr('data-bird-name-resource-key'),
                label: $birdList[i].innerHTML
            };
            itemsForSelection.push(item);
        }

        // call autocomplete function
        $birdSearch.autocomplete({
            minLength: 2,
            source: function source(request, response) {
                var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), 'i');
                response($.grep(itemsForSelection, function (item) {
                    return matcher.test(item.label);
                }));
            },
            appendTo: $('.add-bird-input'),
            focus: function focus(e, ui) {
                e.preventDefault();
                $birdSearch.val(ui.item.label);
                $('.field-validation-error').remove();
            },
            select: function select(e, ui) {
                e.preventDefault();
                $birdSearch.val(ui.item.label);
            }
        });

        // Add selected bird as an item
        context.on('click', '[data-binding="add-bird-button"]', function (e) {
            e.preventDefault();
            var inputValue = $birdSearch.val();
            var birdList = context.find('[data-binding="bird-list"]');
            var index = getItemIndexByLabel(inputValue);

            if (index !== 0 && index !== null) {
                var itemToAdd = itemsForSelection[index];
                events.publish('clone-bird', {
                    toClone: birdList.find('[data-binding="bird-item"]').parent().last(),
                    name: itemToAdd.label,
                    id: itemToAdd.value.split('|')[0],
                    resourceKey: itemToAdd.value.split('|')[1]
                });
                itemsForSelection.splice(index, 1);
            } else {
                if ($birdSearch.siblings('.field-validation-error').length === 0) {
                    $birdSearch.after('<span class="field-validation-error">' + $birdSearch.data('error-message') + '.</span>');
                }
            }
            $birdSearch.val('');
        });
    }

    events.subscribe('clone-bird', function (options) {

        var elementToBeCloned = options.toClone;
        var clone = elementToBeCloned.clone();
        var cloneName = options.name;
        var cloneId = options.id;
        var cloneResourceKey = options.resourceKey;

        clone = clone[0].outerHTML;

        clone = $(clone);

        var clonedIndex = parseInt(clone.attr('data-index'));
        var newIndex = clonedIndex + 1;
        var nameAttrPrefix = 'Birds[' + newIndex + '].';

        /// Update DOM
        clone.attr('data-index', newIndex);

        clone.find('[data-binding="bird-name"]').text(cloneName);
        clone.find('[data-binding="bird-image"]')[0].src = '/Static/images/bgbw/birds/' + cloneId + '.jpg';

        clone.find('[data-binding="bird-name"]').attr('for', cloneId);

        clone.find('input[data-binding="input-id"]').attr('id', 'Birds_' + newIndex + '__Id').attr('name', nameAttrPrefix + 'Id').val(cloneId);

        clone.find('input[data-binding="input-name"]').attr('id', 'Birds_' + newIndex + '__Name').attr('name', nameAttrPrefix + 'Name').val(cloneResourceKey);

        clone.find('input[data-binding="input-number"]').attr('id', cloneId).attr('name', nameAttrPrefix + 'Count').val('0').hide();

        clone.find('[data-binding="decrease-number"]').hide();

        /// Bind a new click element (see input-number.js)
        clone.one('click', function (e) {
            e.stopPropagation();
            clone.find('[data-binding="increase-number"]').trigger('click');
        });

        /// Insert the clone
        elementToBeCloned.after(clone);
    });

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bgbw/bird-select.js
// module id = 217
// module chunks = 0